<template>
    <div class="d-flex justify-space-around align-center createAccountWrapper">
        <v-card class="elevation-8 createAccount-card-wrapper" dark shaped>
            <div
                class="createAccountContentWrapper d-flex justify-space-around align-center flex-column"
            >
                <v-icon color="white" size="150">
                    {{ mdiAccount }}
                </v-icon>
                <h2 class="headline">
                    Create Account
                </h2>
                <h4 class="my-5 red--text text-center">
                    {{ error ? error : '' }}
                </h4>
                <v-form
                    ref="form"
                    v-model="valid"
                    lazy-validation
                    class="createAccountForm"
                >
                    <div class="membcode">
                        <v-text-field
                            v-model="getMembcode"
                            v-mask="membcodemask"
                            label="Member Code"
                            color="white"
                            :prepend-inner-icon="mdiAccount"
                            autocomplete="nope"
                            readonly
                        />
                    </div>
                    <div class="membcode">
                        <v-text-field
                            v-model="password"
                            :append-icon="showPass ? mdiEye : mdiEyeOff"
                            :type="showPass ? 'text' : 'password'"
                            label="Password"
                            hint="At least 8 characters and contains an uppercase, lowercase and number"
                            :rules="rules.passRules"
                            color="white"
                            :prepend-inner-icon="mdiLock"
                            autocomplete="nope"
                            @click:append="showPass = !showPass"
                        />
                    </div>
                    <div class="membcode">
                        <v-text-field
                            v-model="retypedPassword"
                            label="Re-type Password"
                            color="white"
                            :prepend-inner-icon="mdiLock"
                            autocomplete="nope"
                            :rules="[v=>!!v||'Re-type password is required',password===retypedPassword||'Password do not match']"
                            :append-icon="showpRetypePass ? mdiEye : mdiEyeOff"
                            :type="showpRetypePass ? 'text' : 'password'"
                            @click:append="showpRetypePass = !showpRetypePass"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="email"
                            label="Email address"
                            color="white"
                            autocomplete="nope"
                            :prepend-inner-icon="mdiMail"
                            :rules="rules.emailRules"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="cpno"
                            v-mask="contactNumMask"
                            label="Contact number"
                            color="white"
                            autocomplete="nope"
                            :rules="rules.contactRule"
                            :prepend-inner-icon="mdiPhone"
                        />
                    </div>
                    <br>
                    <h5>Address</h5>
                    <div class="bday">
                        <v-text-field
                            v-model="addr_1"
                            label="Address Line 1 (Blk/Lt/Unit/Tower)"
                            color="white"
                            autocomplete="nope"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="addr_2"
                            label="Address Line 2 (Street/Subd./Condo)"
                            color="white"
                            autocomplete="nope"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="barangay"
                            label="Barangay"
                            color="white"
                            autocomplete="nope"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="district"
                            label="District"
                            color="white"
                            autocomplete="nope"
                        />
                    </div>
                    <div class="bday">
                        <v-text-field
                            v-model="zip"
                            v-mask="zipMask"
                            label="ZIP"
                            color="white"
                            autocomplete="nope"
                            :rules="rules.zipRule"
                        />
                    </div>

                    <!-- Region -->
                    <div class="bday">
                        <v-autocomplete
                            v-model="region"
                            color="green accent-4"
                            label="Region"
                            :items="regionItems"
                            :loading="locLoading"
                            item-text="city_region"
                            item-value="city_region"
                            return-object
                            clearable
                            autocomplete="nope"
                            @change="onRegionChange"
                        />
                    </div>

                    <!-- Province (subtext: region) -->
                    <div class="bday">
                        <v-autocomplete
                            v-model="province"
                            color="green accent-4"
                            label="Province"
                            :items="provinceItems"
                            :loading="locLoading"
                            item-text="city_province"
                            item-value="uid"
                            return-object
                            clearable
                            autocomplete="nope"
                            @change="onProvinceChange"
                        >
                            <template #item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.city_province }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.city_region }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </div>

                    <!-- City (subtext: province, region) -->
                    <div class="bday">
                        <v-autocomplete
                            v-model="city"
                            color="green accent-4"
                            label="City"
                            :items="cityItems"
                            :loading="locLoading"
                            item-text="city_name"
                            item-value="uid"
                            return-object
                            clearable
                            autocomplete="nope"
                            @change="onCityChange"
                        >
                            <template #item="{ item }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ item.city_name }}</v-list-item-title>
                                    <v-list-item-subtitle>{{ item.city_province }}, {{ item.city_region }}</v-list-item-subtitle>
                                </v-list-item-content>
                            </template>
                        </v-autocomplete>
                    </div>

                    <!-- Consent -->
                    <div class="mb-3 d-flex justify-space-around">
                        <v-checkbox
                            v-model="accepted"
                            class="ml-5"
                            dense
                            hide-details
                            :rules="rules.consentRule"
                            color="success"
                        />
                        <div
                            class="text-justify font-weight-regular my-3"
                            style="height:100px; overflow-x:hidden; overflow-y:scroll; padding-right:5%"
                        >
                            <div>
                                <h6>
                                    <span class="ml-3"></span> I certify that the information I have
                                    provided is true, correct and complete. I hereby give my full
                                    consent to HMI to collect record, and process information,
                                    whether personal, sensitive or privileged, pertaining to
                                    myself for the purpose of processing medical claims as a prospective
                                    client and member of HMI and for marketing, historical and statistical purposes.
                                    In this connection, I acknowledge that I have read, understood and/or have
                                    been duly informed of the
                                    <a
                                        href="https://www.hmi.com.ph/data-privacy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        style="color:green"
                                    >Data Privacy Statement</a>
                                    pertaining to the data privacy practices of HMI. I hereby express my full conformity thereto.
                                </h6>
                            </div>
                        </div>
                    </div>
                </v-form>

                <vue-recaptcha
                    id="create-account-captcha"
                    ref="createRecaptchaRef"
                    sitekey="6LfoFcYZAAAAADjyyS2cTbKM1ClbgZDImPrIjdxd"
                    theme="dark"
                    load-recaptcha-script
                    @verify="onCaptchaVerify"
                />
                <p class="red--text" style="font-size:15px;">
                    {{ captchaErr ? captchaErr : '' }}
                </p>

                <v-btn
                    color="green accent-4"
                    width="90%"
                    class="white--text my-5"
                    :loading="loading"
                    @click="validate( getMembcode, getBirthdate, displayAccountName, getStatus)"
                >
                    Create Account
                </v-btn>
                <errDiag
                    :show-err-diag="true"
                    :result-data="showReqErr"
                    @errorInput="errorInput"
                />

                <errCaptcha
                    :show-err-diag="true"
                    :result-data="showCaptchaErr"
                    @errorInput="errorInput"
                />
            </div>
            <!-- wrapper -->
        </v-card>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import VueRecaptcha from 'vue-recaptcha'
import errDiag from './DialogBoxes/dlg_errCreateAccount.vue'
import errCaptcha from './DialogBoxes/dlg_errCpatcha.vue'
import { mdiAccount, mdiEye, mdiEyeOff, mdiLock, mdiMail, mdiPhone } from '@mdi/js'
import { moment } from '../../utils/date-shim'

export default {
    components: { VueRecaptcha, errDiag, errCaptcha },
    directives: {
        mask
    },
    data: () => ({
        mdiAccount, mdiEye, mdiEyeOff, mdiLock, mdiMail, mdiPhone,
        loading: false,
        locLoading: false,
        membcodemask: '######',
        contactNumMask: '###########',
        // V-models
        password: '',
        retypedPassword: '',
        membCode: '',
        cpno: '',
        email: '',
        valid: true,
        captchaCheck: '',
        showPass: false,
        showpRetypePass: false,
        addr_1: '',
        addr_2: '',
        barangay: '',
        district: '',
        zip: '',
        zipMask: '####',
        accepted: false,

        // Local copies of the master lists
        allRegions: [],   // from regions()
        allProvinces: [], // from provinces()
        allCities: [],    // from cities()

        // Selected objects
        region: null,
        province: null,
        city: null,

        rules: {
            passRules: [
                (validation) => !!validation || 'Password is required',
                (validation) =>
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d!@#$%^&*()-_=+{};:,.<>?/\\|\[\]~]{8,}$/.test(validation) ||
                    'Must contain uppercase, lowercase and number and at least 8 characters '
            ],
            zipRule: [
                (validation) => /^$/.test(validation) || /^\d{4}$/.test(validation) || 'Invalid ZIP Code'
            ],
            emailRules: [
                (validation) => !!validation || 'E-mail is required',
                (validation) => /^\s*[a-zA-Z0-9]+([._%-][a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}\s*$/.test(validation) || 'E-mail must be valid'
            ],
            contactRule: [
                (validation) => !!validation || 'Contact number is required',
                (validation) =>
                    /^[0-9() ]+$/.test(validation) || 'Invalid Input, numbers only'
            ],
            consentRule: [(validation) => !!validation || 'Please check the box to confirm you have read and agree to the terms.']
        },
        captchaToken: null
    }),
    computed: {
        ...mapGetters([
            'displayAccountName',
            'getValidationFour',
            'getStatus',
            'getMembcode',
            'getBirthdate',
            'emailModifier',
            'error',
            'captchaErr',
            'getRegions',
            'getProvinces',
            'getCities'
        ]),
        showReqErr: {
            get() {
                try {
                    if (String(this.error).trim() !== '') {
                        return this.error
                    } else {
                        return ''
                    }
                } catch (e) {
                    return false
                }
            }
        },
        showCaptchaErr: {
            get() {
                try {
                    if (String(this.captchaErr).trim() !== '') {
                        return this.captchaErr
                    } else {
                        return ''
                    }
                } catch (e) {
                    return false
                }
            }
        },

        // Regions from regions(), plus any found only in the city list
        regionItems() {
            const names = new Set()
            this.allRegions.forEach(r => r.city_region && names.add(r.city_region))
            this.allCities.forEach(c => c.city_region && names.add(c.city_region))
            return [...names].sort().map(n => ({ city_region: n }))
        },

        // Provinces from provinces(), plus any found only in the city list,
        // limited to the selected region (if any)
        provinceItems() {
            const map = new Map()
            const add = (p) => {
                if (!p.city_province) return
                if (this.region && p.city_region !== this.region.city_region) return
                const uid = `${p.city_region}|${p.city_province}`
                if (!map.has(uid)) {
                    map.set(uid, { uid, city_province: p.city_province, city_region: p.city_region })
                }
            }
            this.allProvinces.forEach(add)
            this.allCities.forEach(add)

            // make sure the selected province is always in the list so it displays
            if (this.province && this.province.uid && !map.has(this.province.uid)) {
                map.set(this.province.uid, this.province)
            }
            return [...map.values()].sort((a, b) => a.city_province.localeCompare(b.city_province))
        },

        // Cities, limited by selected region and/or province
        cityItems() {
            return this.allCities
                .filter(c =>
                    (!this.region || c.city_region === this.region.city_region) &&
                    (!this.province || (
                        c.city_province === this.province.city_province &&
                        c.city_region === this.province.city_region
                    ))
                )
                .sort((a, b) => a.city_name.localeCompare(b.city_name))
        }
    },
    watch: {
        getValidationFour() {
            this.loading = false
        },
        // copy store lists into local state whenever they arrive
        getRegions() { this.syncLocations() },
        getProvinces() { this.syncLocations() },
        getCities() { this.syncLocations() },
        region(val) {
            if (!val) {
                this.province = null
                this.city = null
            }
        },
        province(val) {
            if (!val) this.city = null
        }
    },
    created () {
        this.loadLocations()
    },
    methods: {
        ...mapActions(['toSignupLogin', 'validationFour', 'regions', 'provinces', 'cities', 'getCsrfToken']),
        handleChangeRegion(item) {
            if (!item) {
                this.provinceObj = null
                this.cityObj = null
                return
            }
            if (this.provinceObj && this.provinceObj.city_region !== item.city_region) {
                this.provinceObj = null
            }
            if (this.cityObj && this.cityObj.city_region !== item.city_region) {
                this.cityObj = null
            }
        },

        handleChangeProvince(item) {
            if (!item) {
                this.cityObj = null
                return
            }
            this.regionObj = { city_region: item.city_region }
            if (this.cityObj && (
                this.cityObj.city_province !== item.city_province ||
                this.cityObj.city_region !== item.city_region
            )) {
                this.cityObj = null
            }
        },

        loadLocations() {
            this.locLoading = true
            this.syncLocations() // in case the store already has data

            const safe = (p) => Promise.resolve(p).catch(() => null)
            Promise.all([
                safe(this.regions()),
                safe(this.provinces({ REGION: '' })),
                safe(this.cities({ REGION: '', PROVINCE: '' }))
            ]).then(() => {
                this.syncLocations()
                this.locLoading = false
            })
        },

    
        // Copy store lists into local state. A list is only replaced if the new one
        // is at least as big, so a filtered call elsewhere can't shrink it.
        syncLocations() {
            const clean = (list) => (list || []).map(x => ({
                ...x,
                city_name: x.city_name ? String(x.city_name).trim() : undefined,
                city_province: String(x.city_province || '').trim(),
                city_region: String(x.city_region || '').trim()
            }))

            const regs = clean(this.getRegions)
            const provs = clean(this.getProvinces)
            const cities = clean(this.getCities)
                .filter(c => c.city_name)
                .map(c => ({
                    ...c,
                    uid: `${c.city_region}|${c.city_province}|${c.city_name}`
                }))

            if (regs.length >= this.allRegions.length) this.allRegions = regs
            if (provs.length >= this.allProvinces.length) this.allProvinces = provs
            if (cities.length >= this.allCities.length) this.allCities = cities
        },

        // Region picked -> drop province/city that don't belong to it
        onRegionChange(item) {
            if (!item) return
            if (this.province && this.province.city_region !== item.city_region) {
                this.province = null
            }
            if (this.city && this.city.city_region !== item.city_region) {
                this.city = null
            }
        },

        // Province picked -> auto-fill region, keep only cities under it
        onProvinceChange(item) {
            if (!item) return
            this.region = { city_region: item.city_region }
            if (this.city && (
                this.city.city_province !== item.city_province ||
                this.city.city_region !== item.city_region
            )) {
                this.city = null
            }
        },

        // City picked -> auto-fill province and region
        onCityChange(item) {
            if (!item) return
            this.region = { city_region: item.city_region }
            this.province = {
                uid: `${item.city_region}|${item.city_province}`,
                city_province: item.city_province,
                city_region: item.city_region
            }
        },

        validate(membCode, birthdate, username, status) {
            this.loading = true
            this.showPass = false
            this.showpRetypePass = false
            this.$refs.form.validate()

            const errors = []
            this.$refs.form.$children.forEach(child => {
                if (child.errorBucket && child.errorBucket.length) {
                    errors.push(...child.errorBucket)
                }
            })

            this.validationFour({
                MEMBNO: membCode,
                USERNAME: username,
                PASSWORD: this.password,
                BIRTHDATE: birthdate,
                RETYPEDPASS: this.retypedPassword,
                EMAIL: this.email.trim(),
                CPNO: this.cpno,
                STATUS: status,
                CREATED_AT: moment().utcOffset('+0800').format('YYYY-MM-DD HH:mm:ss'),
                CAPTCHA: this.captchaToken,
                ADDRESS: {
                    ADDR_1: this.addr_1,
                    ADDR_2: this.addr_2,
                    BARANGAY: this.barangay,
                    DISTRICT: this.district,
                    CITY: this.city ? this.city.city_name : '',
                    PROVINCE: this.province ? this.province.city_province : '',
                    REGION: this.region ? this.region.city_region : '',
                    ZIP: this.zip
                },
                errors
            })
        },
        errorInput(param) {
            this.loading = false
            if (this.$refs && this.$refs.createRecaptchaRef) {
                this.$refs.createRecaptchaRef.reset()
            }
            this.$store.commit('SET_ERROR_MESSAGE', param)
        },
        onCaptchaVerify(token) {
            this.captchaToken = token
        }
    }
}
</script>

<style scoped>
.createAccountWrapper {
  height: 100%;
}
/* CARD Component */
.createAccount-card-wrapper {
  width: 30%;
  height: 75%;
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

/* Container of all components */
.createAccountContentWrapper {
  height: 100%;
  width: 60%;
  margin: auto;
}
/* Register FORM */
.createAccountForm {
  margin: 20px auto;
  width: 90%;
}
/* Text fields */
.membcode,
.bday {
  width: 100%;
}

span {
  cursor: pointer;
  font-weight: bold;
  color: white;
}
@media (max-width: 599px) {
  .createAccount-card-wrapper {
    width: 90%;
  }
  .createAccountContentWrapper {
    width: 90%;
  }
}
@media (min-width: 599px) and (max-width: 968px) {
  .createAccount-card-wrapper {
    width: 70%;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .createAccount-card-wrapper {
    width: 60%;
  }
}
</style>